import { UPDATE_THREAD_ID } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function updateCallingThreadId(threadData) {
  return callingAPIMethodWithQueue(UPDATE_THREAD_ID, threadData);
}